module.exports = __webpack_public_path__ + "static/media/44.2b6a733c.jpg";